module.exports = __webpack_public_path__ + "static/imagination-org@2x-30954e21ba164d978fcf9e8e1f855e36.png";